import React from "react";

function UserGuide() {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="container py-5">
          <h2 className="text-center mb-4">User Guide</h2>
          <video
            src={`${process.env.PUBLIC_URL}/video/user-guide.mp4`}
            style={{ width: "40%" }}
            controls
          ></video>
          <h6>Dashboard Guide in Hindi</h6>
        </div>
      </div>
    </div>
  );
}

export default UserGuide;
